module.exports = __webpack_public_path__ + "27b82c6ebb61fa5fe1ea0624c3adf2c2.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicon.png
// module id = 308
// module chunks = 0